export function initSkipToMainContent() {
	const skipLink = document.querySelector(".js-skip-to-main-content-link");
	const skipMessage = document.querySelector(
		".js-skip-to-main-content-message"
	);
	const mainContent = document.getElementById("main-content");

	if (!skipLink || !skipMessage || !mainContent) return;

	let messageVisible = false;

	// Mostra il messaggio quando il link riceve focus (primo Tab)
	skipLink.addEventListener("focus", () => {
		skipMessage.classList.remove("hidden");
		messageVisible = true;
	});

	// Nasconde il messaggio quando il link perde focus (secondo Tab)
	skipLink.addEventListener("blur", () => {
		if (messageVisible) {
			skipMessage.classList.add("hidden");
			messageVisible = false;
		}
	});

	// Funzione per scrollare e nascondere il messaggio
	const scrollToMainContent = () => {
		mainContent.scrollIntoView({ behavior: "smooth" });
		skipMessage.classList.add("hidden");
		messageVisible = false;
		skipLink.blur(); // Rimuove focus dal link per evitare trigger successivi
	};

	// Click sul messaggio
	skipMessage.addEventListener("click", scrollToMainContent);

	// Enter o Space quando il messaggio ha focus
	skipMessage.addEventListener("keydown", (e) => {
		if (e.key === "Enter" || e.key === " ") {
			e.preventDefault();
			scrollToMainContent();
		}
	});

	// Enter o Space quando il link stesso ha focus
	skipLink.addEventListener("keydown", (e) => {
		if (e.key === "Enter" || e.key === " ") {
			e.preventDefault();
			scrollToMainContent();
		}
	});
}
